<template>
  <div class="welcome-dialog-container" v-if="visible">
    <div class="welcome-message">Welcome To</div>
    <div class="youpaired-message">YouPaired</div>
    <div class="main-content">
      <div class="stage-container">
        <font-awesome-icon :icon="['fas', 'tv']" size="6x" class="stage-image">
        </font-awesome-icon>
        <label>Watch</label>
        <div class="stage-text"> Watch live beats and level up!
        </div>
      </div>
      <div class="arrow">
        <font-awesome-icon :icon="['fas', 'long-arrow-alt-right']" size="4x">
        </font-awesome-icon>
      </div>
      <div class="stage-container">
        <font-awesome-icon :icon="['fas', 'gem']" size="6x" class="stage-image">
        </font-awesome-icon>
        <label>Discover</label>
        <div class="stage-text">
          Discover the best beats, and share your favorite moments with your friends!
        </div>
      </div>
      <div class = "arrow">
        <font-awesome-icon :icon="['fas', 'long-arrow-alt-right']" size="4x">
        </font-awesome-icon>
      </div>
      <div class="stage-container">
        <font-awesome-icon :icon="['fas', 'hand-holding-usd']" size="6x" class="stage-image">
        </font-awesome-icon>
        <label> Support </label>
        <div class="stage-text"> Support your favorite artist!
        </div>
      </div>
    </div>
    <div class="start">
      <button class="start-watching" @click="hideDialog"> Stream & Watch </button>
    </div>
    <font-awesome-icon :icon="['fas', 'times']" size="2x" class="welcome-dialog-close"
      @click="hideDialog">
    </font-awesome-icon>
  </div>
</template>

<script>
export default {
  name: 'WelcomeDialog',
  data() {
    return {
      visible: true,
    };
  },
  methods: {
    hideDialog() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
.welcome-dialog-container {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 200;
  position: fixed;
  width: 56rem;
  height: 35rem;
  text-align: center;
  border-radius: 1rem;
  background-color: #ffffff;

  -webkit-box-shadow:0 0 1.25rem rgba(0,0,0,0.8);
  -moz-box-shadow:0 0 1.25rem rgba(0,0,0,0.8);
  box-shadow:0 0 1.25rem rgba(0,0,0,0.8);
}

.welcome-message{
  margin-top: 3rem;
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0.25rem;
}

.youpaired-message{
  margin-top: 1rem;
  text-transform: uppercase;
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.25rem;
}

.stage-container{
  display: flex;
  margin-left: 1rem;
  flex-direction: column;
  align-items: center;
  width: 12rem;
}

.stage-container label{
  margin-top: 1.5rem;
  font-size: 1.2rem;
  text-transform: uppercase;
  text-align: center;
}

.stage-image {

}

.stage-text{
  margin-top: 1.5rem;
  text-align: center;
}

.arrow{
 margin-top: 1rem;
 margin-left: 2rem;
 align-items: center;
 justify-content: center;
 color:#055bff;
}

.welcome-dialog-close{
  position: absolute;
  top: 0.625rem;
  right: 1rem;
  cursor: pointer;
  &:hover {
    filter: brightness(0.6);
    -webkit-filter: brightness(0.6);
  }
}

.start{
  display: flex;
  align-items: center;
  justify-content: center;
}

.start-watching{
  position: absolute;
  bottom: 1.3rem;
  width: 15rem;
  height: 2.5rem;
  color: #ffffff;
  background-color: #055BFF;
  text-transform: uppercase;
  font-size: 1rem;
  border-radius: 0.2rem;
  cursor: pointer;
}

.main-content {
  display: flex;
  margin-top:4rem;
  justify-content: center;
}
</style>
